import script from "./MessagesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesPanel.vue?vue&type=script&setup=true&lang=js"

import "./MessagesPanel.vue?vue&type=style&index=0&id=4442f2af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4442f2af"]])

export default __exports__